var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{attrs:{"title":"Important Dates"}},_vm._l((_vm.details),function(detail,index){return _c('Detail',{key:index,attrs:{"name":detail.name,"description":detail.description,"custom-class":detail.customClass}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }